import React from "react";

function BS4_Navs() {
  return (
    <div>
      <h1>BS4_Navs Component</h1>
      <p>This is the BS4_Navs tutorial page content.</p>
    </div>
  );
}

export default BS4_Navs;
